var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamilygroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3223",
    "data-name": "Group 3223",
    transform: "translate(-1140 -115)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 120,
    height: 120,
    rx: 60,
    transform: "translate(1140 115)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1672",
    "data-name": "Group 1672",
    transform: "translate(1172.726 147.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M-411.616,426.651c-4.527,0-9.055.012-13.582-.007a8.184,8.184,0,0,1-4.944-1.526,6.881,6.881,0,0,1-2.873-5.459,29.409,29.409,0,0,1,1.477-11.159,11.55,11.55,0,0,1,3.472-5.323,8.325,8.325,0,0,1,5.322-1.835,2.442,2.442,0,0,1,1.17.432c.851.51,1.649,1.108,2.5,1.612a13.8,13.8,0,0,0,14.722.106,11.634,11.634,0,0,0,1.9-1.261,4.058,4.058,0,0,1,3.9-.668,8.974,8.974,0,0,1,6.107,5.247,20.105,20.105,0,0,1,1.874,6.664,49.9,49.9,0,0,1,.331,5.624,7.188,7.188,0,0,1-6.742,7.46,14.3,14.3,0,0,1-1.538.09Q-405.065,426.658-411.616,426.651Z",
    transform: "translate(438.902 -372.109)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M-330.073,223.37a11.662,11.662,0,0,1-11.721-11.67,11.68,11.68,0,0,1,11.678-11.716A11.674,11.674,0,0,1-318.4,211.656,11.666,11.666,0,0,1-330.073,223.37Z",
    transform: "translate(357.365 -192.202)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M-454.2,134.72a7.739,7.739,0,0,1-7.743,7.79,7.757,7.757,0,0,1-7.856-7.737,7.791,7.791,0,0,1,7.669-7.828A7.758,7.758,0,0,1-454.2,134.72Z",
    transform: "translate(471.73 -126.945)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M-132.787,142.508a7.74,7.74,0,0,1-7.789-7.8,7.76,7.76,0,0,1,7.831-7.767,7.782,7.782,0,0,1,7.768,7.783A7.761,7.761,0,0,1-132.787,142.508Z",
    transform: "translate(177.584 -126.943)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M-124.62,275.608c1.1.177,2.157.391,3.224.51a11.838,11.838,0,0,0,6.256-1.342c.66-.3,1.293-.658,1.94-.986a1.875,1.875,0,0,1,2.234.557.824.824,0,0,1,.1.446c.005,4.312,0,8.625.012,12.937a.574.574,0,0,1-.347.575,7.732,7.732,0,0,1-3.79.869c-1.171.018-2.343.014-3.514-.006a.829.829,0,0,1-.555-.215,10.673,10.673,0,0,0-7.884-3.693A13.552,13.552,0,0,0-124.62,275.608Z",
    transform: "translate(165.403 -257.999)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M-471.865,285.232a10.645,10.645,0,0,0-6.586,2.441,6.181,6.181,0,0,0-.957.92,1.465,1.465,0,0,1-1.38.57c-1.382-.058-2.767-.035-4.149-.091a5.684,5.684,0,0,1-2.712-.837.673.673,0,0,1-.289-.48q-.023-6.522,0-13.044a.853.853,0,0,1,.246-.54,1.8,1.8,0,0,1,2.27-.307,18.619,18.619,0,0,0,5.469,2.116,11.426,11.426,0,0,0,5.253-.359l.524-.15A13.568,13.568,0,0,0-471.865,285.232Z",
    transform: "translate(487.95 -257.972)",
    fill: "#7a7a7a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilygroup);
export default __webpack_public_path__ + "static/media/familygroup.055c4f81314cdc4d225599f76f27cc8d.svg";
export { ForwardRef as ReactComponent };